import { graphql } from 'react-apollo'
import getImageFromEntry, {
  MASTER,
  STANDARD,
} from '../../helpers/get-image-from-entry'
import getDescriptiveLocation from '../../helpers/get-descriptive-location'
import getSponsoredTitle from '../../helpers/get-sponsored-topic'
import { ApplicationError } from '../../helpers/errors'
import { DateTime, localISODate } from '../../helpers/date-helpers'
import showItem from '../../helpers/show-item-helper'
import { getOccurrences } from './../../helpers/occurrences'
import query from './query.graphql'
import getBrowser, { isMobile } from './../../helpers/get-browser'

export { query }

export const mapPropsToOptions = ({ centre, id }) => ({
  variables: {
    id,
    centreId: centre.sys.id,
    startsAt: localISODate(centre.timeZone),
  },
  errorPolicy: 'ignore',
})

export const mapDataToProps = ({
  ownProps: { centre: ownCentre, id, slug },
  data: { centre: respCentre, loading, error },
  context,
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!respCentre || !respCentre.event) {
    const expiredEventText = {
      category: 'Event',
      topic: 'Event',
      title: 'Sorry, that event has expired',
      body: `The event you selected has expired.`,
    }
    return {
      entry: {
        ...expiredEventText,
        store: null,
      },
    }
  } else if (slug !== respCentre.event.slug) {
    return {
      redirect: `/${ownCentre.slug}/event/${id}/${respCentre.event.slug}`,
    }
  }

  const { event } = respCentre
  const allStores = (event.stores || []).filter(
    store => store.centre.sys.id === ownCentre.sys.id
  )
  const store = allStores.length === 1 ? allStores[0] : null
  const now = DateTime.local({ timeZone: respCentre.timeZone })
  const location = getDescriptiveLocation({
    level: event.level,
    physicalAddress: event.physicalAddress,
    hosted: event.hosted,
    ...(store && { storeTitle: store.storeTitle }),
  })
  const inclCalendar = isMobile(getBrowser(context))
  if (showItem(now, ownCentre.timeZone, event)) {
    return {
      entry: {
        category: 'Event',
        topic: getSponsoredTitle(event),
        title: event.title,
        slug: event.slug,
        shortDescription: event.shortDescription,
        priceInfo: event.priceDescription,
        desktopImage: getImageFromEntry(event, MASTER),
        mobileImage: getImageFromEntry(event, STANDARD),
        experiences: event.experiences,
        retailCategories: event.retailCategories,
        topics: event.topics,
        typename: event.__typename,
        occurrences: getOccurrences(
          false,
          event,
          ownCentre.timeZone,
          inclCalendar
        ),
        body: event.bodyCopy,
        termsAndConditions: event.termsAndConditions,
        location,
        callsToAction: event.callsToAction,
        stores: event.stores,
        store,
        analyticsMetadata: event.analyticsMetadata,
      },
    }
  } else {
    const expiredEventText = {
      category: 'Event',
      topic: 'Event',
      title: 'Sorry, that event is no longer valid',
      body: `The event you selected is no longer valid.`,
    }
    return {
      entry: {
        ...expiredEventText,
        store,
        isExpired: true,
      },
    }
  }
}

const withEventDetail = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withEventDetail
